import type { DocumentSectionTree } from '../types'

export type HierarchyViewMode = 'all' | 'sections' | 'tables'

function keepLeafInView(type: DocumentSectionTree['type'], mode: HierarchyViewMode): boolean {
  if (mode === 'sections') return type === 'text'
  if (mode === 'tables') return type === 'table'
  return true
}

function filterNodes(nodes: DocumentSectionTree[], mode: HierarchyViewMode): DocumentSectionTree[] {
  return nodes.flatMap((node) => {
    if (node.type === 'heading') {
      const filteredChildren = filterNodes(node.children, mode)
      if (filteredChildren.length === 0) return []

      return [{ ...node, children: filteredChildren }]
    }

    return keepLeafInView(node.type, mode) ? [{ ...node, children: [] }] : []
  })
}

/** Display-only filter for the Files page hierarchy. Does not change selection state. */
export function filterSectionTree(
  nodes: DocumentSectionTree[],
  mode: HierarchyViewMode
): DocumentSectionTree[] {
  if (mode === 'all') return nodes
  return filterNodes(nodes, mode)
}
